window.$ = window.jQuery = require('jquery');
require('./style.css');
require('./apex.core.v3.js');
require('./apex.embed.v3.js');
window.config={getScriptForAds:function(r, i){i();}}